import { __read } from "tslib";
import { useCallback } from 'react';
import { useControlled } from '../../../../utils/hooks/useControlled';
export function useControlledCheck(_a) {
    var controlledChecked = _a.controlledChecked, defaultChecked = _a.defaultChecked, componentName = _a.componentName, changeHandlerProp = _a.changeHandler;
    var _b = __read(useControlled({
        controlled: controlledChecked,
        default: !!defaultChecked,
        name: componentName,
        state: 'checked',
    }), 2), checked = _b[0], setChecked = _b[1];
    var changeHandler = useCallback(function (e) {
        e.persist();
        setChecked(e.target.checked);
        changeHandlerProp === null || changeHandlerProp === void 0 ? void 0 : changeHandlerProp(e);
    }, [changeHandlerProp]);
    return {
        checked: checked,
        setChecked: setChecked,
        changeHandler: changeHandler,
    };
}
//# sourceMappingURL=useControlledCheck.js.map